/**
 * Componente și constante comune pentru Admin Dashboard
 */

// Helper pentru generarea opțiunilor de ore
export const timeOptions = [];
for (let h = 5; h <= 22; h++) {
  for (let m = 0; m < 60; m += 30) {
    const hour = h.toString().padStart(2, '0');
    const minute = m.toString().padStart(2, '0');
    timeOptions.push(`${hour}:${minute}`);
  }
}

// Mapare luni în română
export const MONTHS_RO = {
  1: 'Ianuarie', 2: 'Februarie', 3: 'Martie', 4: 'Aprilie',
  5: 'Mai', 6: 'Iunie', 7: 'Iulie', 8: 'August',
  9: 'Septembrie', 10: 'Octombrie', 11: 'Noiembrie', 12: 'Decembrie'
};

// Mapare roluri în română
export const ROLE_LABELS = {
  admin: 'Administrator',
  fleet_manager: 'Manager Flotă',
  contabilitate: 'Contabilitate',
  juridic: 'Juridic',
  dispatcher: 'Dispecer',
  tesa: 'TESA',
  driver: 'Șofer'
};

// Statusuri vehicule
export const CAR_STATUS_LABELS = {
  available: { label: 'Disponibil', color: 'bg-green-100 text-green-800' },
  in_use: { label: 'În cursă', color: 'bg-blue-100 text-blue-800' },
  nonavailable: { label: 'Indisponibil', color: 'bg-gray-100 text-gray-800' },
  damaged: { label: 'Avariat', color: 'bg-red-100 text-red-800' },
  engine_problem: { label: 'Defect motor', color: 'bg-orange-100 text-orange-800' }
};

// Valori pontaj
export const PONTAJ_VALUES = {
  '8': { label: '8 ore', color: 'bg-green-100 text-green-800' },
  '6': { label: '6 ore', color: 'bg-green-50 text-green-700' },
  '4': { label: '4 ore', color: 'bg-yellow-100 text-yellow-800' },
  '2': { label: '2 ore', color: 'bg-yellow-50 text-yellow-700' },
  'CO': { label: 'Concediu', color: 'bg-blue-100 text-blue-800' },
  'CM': { label: 'Medical', color: 'bg-purple-100 text-purple-800' },
  'CFP': { label: 'Fără plată', color: 'bg-orange-100 text-orange-800' },
  'NM': { label: 'Nemotivată', color: 'bg-red-100 text-red-800' },
  'DEM': { label: 'Demisie', color: 'bg-slate-100 text-slate-800' },
  'X': { label: 'Neangajat', color: 'bg-slate-50 text-slate-500' }
};

// Helper pentru a obține eticheta unui rol
export const getRoleLabel = (role) => ROLE_LABELS[role] || role;

// Angajat activ = fără demisie (aceeași regulă ca filtrul Activi/Foști din Angajați)
export const isActiveEmployee = (u) => !!u && u.fost_angajat !== true && !u.pontaj_pana_la;

// Helper pentru a formata data
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('ro-RO');
  } catch {
    return dateString;
  }
};

// Helper pentru a calcula zilele până la expirare
export const getDaysUntilExpiry = (dateString) => {
  if (!dateString) return null;
  try {
    const expiryDate = new Date(dateString);
    const today = new Date();
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  } catch {
    return null;
  }
};

// Helper pentru a obține clasa de culoare pentru expirare
export const getExpiryColorClass = (daysUntilExpiry) => {
  if (daysUntilExpiry === null) return '';
  if (daysUntilExpiry < 0) return 'text-red-600 font-bold';
  if (daysUntilExpiry <= 7) return 'text-red-500';
  if (daysUntilExpiry <= 30) return 'text-orange-500';
  if (daysUntilExpiry <= 60) return 'text-yellow-600';
  return 'text-green-600';
};
